<template>
    <div>
        <h2>关账日期管理</h2>
        <el-row>
            <el-col :span="4">
                <el-button size="small" @click="addFormVisible = true" style="margin-bottom:10px;">添加订单关账日期</el-button>
               
            </el-col>
            <el-col :span="4">
                <el-button size="small" @click="addCostFormVisible = true" style="margin-bottom:10px;">添加收入关账日期</el-button>
               
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="24">
                <el-table :data="closeData" border stripe style="width: 100%">
                    <el-table-column type="index" label="序号" width="50" min-width="30"></el-table-column>
                    <el-table-column prop="DAY" label="关账日期(号码为本月生效)" min-width="100"></el-table-column>
                    <el-table-column prop="CLOSE_ACCOUNT_DAY" label="关账类型" min-width="100">
                         <template slot-scope="scope">
                           <span v-if="scope.row.TYPE ===1">订单关账</span>
                           <span v-if="scope.row.TYPE ===2">收入关账</span>
                         </template>
                    </el-table-column>
                    <el-table-column
                            fixed="right"
                            label="操作"
                            width="300">
                        <template slot-scope="scope">
                            <el-button type="text" size="small" icon="el-icon-edit-outline"
                                       @click="editType(scope.row)">修改
                            </el-button>
                            <el-button type="text" size="small" icon="el-icon-edit-outline"
                                       @click="incomesType(scope.row)">删除
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-col>
        </el-row>
        <!-- 关账日期添加 -->
        <el-dialog title="订单关账日期添加" center :visible.sync="addFormVisible" width="400px" :close-on-click-modal="false">
            <el-form :model="addForm" ref="addForm"  style="margin-top: 0">
                <el-form-item label="关账日期：" :label-width="formLabelWidth" prop="name"> 
                    <el-select size="small"  v-model="closeDate" placeholder="请选择" :clearable="false">
                        <el-option v-for="item in closeType" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="close('addForm')">取 消</el-button>
                <el-button @click="submitAdd('addForm')">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="收入关账日期添加" center :visible.sync="addCostFormVisible" width="400px" :close-on-click-modal="false">
            <el-form :model="addFormCost" ref="addFormCost"  style="margin-top: 0">
                <el-form-item label="关账日期：" :label-width="formLabelWidth" prop="name"> 
                    <el-select size="small"  v-model="addFormCost.closeDate" placeholder="请选择" :clearable="false">
                        <el-option v-for="item in closeType" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="close('addFormCost')">取 消</el-button>
                <el-button @click="submitAddCost('addFormCost')">确 定</el-button>
            </div>
        </el-dialog>
        <!--修改-->
        <el-dialog title="修改关账日期" center :visible.sync="editFormVisible" width="400px" :close-on-click-modal="false" >
            <el-form :model="editForm" ref="editForm"  style="margin-top: 0">
                <el-form-item label="关账日期：" :label-width="formLabelWidth" prop="name">
                    <el-select size="small"  v-model="changeDate" placeholder="请选择" :clearable="false">
                        <el-option v-for="item in closeType" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="close('editForm')">取 消</el-button>
                <el-button @click="changeDay()" plain>确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import http from '@/api/base/http';
export default {
  data() {
    const name = /^[\u4E00-\u9FA5\uf900-\ufa2d·s]{2,100}$/;
    const validateName = (rule, value, callback) => {
      if (value === '') {
        callback('内容不能为空');
      } else if (name.test(value)) {
        callback();
      } else {
        callback('您输入的格式有误');
      }

    };

    const cost = /^[1-9]\d*|0\,\d*|[1-9]\d*|0$/;
    const validateCost = (rule, value, callback) => {
      if (value === '') {
        callback('内容不能为空');
      } else if (cost.test(value)) {
        callback();
      } else {
        callback('您输入的格式有误');
      }
    };

    return {
        closeDate:'0',
        changeDate:'0',
        closeData:[],
        closeType: [
            {
            label: '1',
            value: '0'
            },
            {
            label: '2',
            value: '1'
            },
            {
            label: '3',
            value: '2'
            },
            {
            label: '4',
            value: '3'
            },
            {
            label: '5',
            value: '4'
            },
            {
            label: '6',
            value: '5'
            },
            {
            label: '7',
            value: '6'
            },
            {
            label: '8',
            value: '7'
            },
            {
            label: '9',
            value: '8'
            },
            {
            label: '10',
            value: '9'
            },
            {
            label: '11',
            value: '10'
            },
            {
            label: '12',
            value: '11'
            },
            {
            label: '13',
            value: '12'
            },
            {
            label: '14',
            value: '13'
            },
            {
            label: '15',
            value: '14'
            },
            {
            label: '16',
            value: '15'
            },
            {
            label: '17',
            value: '16'
            },
            {
            label: '18',
            value: '17'
            },
            {
            label: '19',
            value: '18'
            },
            {
            label: '20',
            value: '19'
            },
            {
            label: '21',
            value: '20'
            },
            {
            label: '22',
            value: '21'
            },
            {
            label: '23',
            value: '22'
            },
            {
            label: '24',
            value: '23'
            },
            {
            label: '25',
            value: '24'
            },
            {
            label: '26',
            value: '25'
            },
            {
            label: '27',
            value: '26'
            },
            {
            label: '28',
            value: '27'
            },
            {
            label: '29',
            value: '28'
            },
            {
            label: '30',
            value: '29'
            },
      ],
      // loading:false,
      incomeTypeListData: [],
      formLabelWidth: '100px',
      addFormVisible: false,
      addCostFormVisible: false,
      editFormVisible: false,
      addForm: {
        name: '',
        ratio: '',
      },
      addFormCost: {
        name: '',
        ratio: '',
      },
      editForm: {
        NAME: '',
        FEE_RATIO: '',
      },
    };
  },
  methods: {
    // 获取关账日期
    queryData() {
      const params = {
        SERVICE_ID: '11011',
        OTYPE: 1,
        TC_ID: Number(sessionStorage.getItem('companyId')),
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
      };
      http.post(params).then((result) => {
        if(result !== []){
            // result[0].CLOSE_ACCOUNT_DAY = result[0].CLOSE_ACCOUNT_DAY + '号'
            this.closeData = result
        }else{
            this.$message.show({ text: '暂无数据', type: 'success' });
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 删除
    incomesType(row) {
        const params = {
        SERVICE_ID: '11011',
        OTYPE: 3,
        TC_ID: Number(sessionStorage.getItem('companyId')),
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        TYPE:row.TYPE
      };
      http.post(params).then((result) => {
        console.log(result);
        this.$message.show({ text: '删除成功', type: 'success' });
        this.queryData()
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
     
    
    },
    // 新增
    submitAdd() {
      if (document.body.style.cursor === 'wait') {

      } else {
        document.body.style.cursor = 'wait';
        try {
          // this.loading = true
          const params = {
            SERVICE_ID: '11011',
            OTYPE: 2,
            TC_ID: Number(sessionStorage.getItem('companyId')),
            USER_ID: sessionStorage.getItem('userId'),
            SESSION: sessionStorage.getItem('session'),
            DAY: Number(this.closeDate) + 1,
            TYPE:1
        };
        http.post(params).then((result) => {
            this.$message.show({ text: '新增成功', type: 'success' });
            this.queryData();
            this.addFormVisible = false
            document.body.style.cursor="default";
        }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor="default";
        });
        } finally {
          // console.log("我执行完了")
          // document.body.style.cursor="default";
        }
      }
    },
    // 新增
    submitAddCost() {
      if (document.body.style.cursor === 'wait') {

      } else {
        document.body.style.cursor = 'wait';
        try {
          // this.loading = true
          const params = {
            SERVICE_ID: '11011',
            OTYPE: 2,
            TC_ID: Number(sessionStorage.getItem('companyId')),
            USER_ID: sessionStorage.getItem('userId'),
            SESSION: sessionStorage.getItem('session'),
            DAY: Number(this.addFormCost.closeDate) + 1,
            TYPE: 2
        };
        http.post(params).then((result) => {
            this.$message.show({ text: '新增成功', type: 'success' });
            this.queryData();
            this.addCostFormVisible = false
            document.body.style.cursor="default";
        }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor="default";
        });
        } finally {
          // console.log("我执行完了")
          // document.body.style.cursor="default";
        }
      }
    },
    changeDay(){
        if (document.body.style.cursor === 'wait') {

      } else {
        document.body.style.cursor = 'wait';
        try {
          // this.loading = true
          const params = {
            SERVICE_ID: '11011',
            OTYPE: 2,
            TC_ID: Number(sessionStorage.getItem('companyId')),
            USER_ID: sessionStorage.getItem('userId'),
            SESSION: sessionStorage.getItem('session'),
            DAY: Number(this.changeDate) + 1,
            TYPE:this.editForm.TYPE
        };
        http.post(params).then((result) => {
            console.log(result);
            this.$message.show({ text: '修改成功', type: 'success' });
            this.queryData();
            this.editFormVisible = false
            document.body.style.cursor="default";
        }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor="default";
        });
        } finally {
          // console.log("我执行完了")
          // document.body.style.cursor="default";
        }
      }
    },
    editType(row) {
      this.editFormVisible = true;
      this.editForm = row
      console.log(row,'ddddddddddd');
      this.changeDate = row.DAY;
    },
    // 关闭弹窗
    close(formName) {
      this.$refs[formName].resetFields();
      const modalName = `${formName}Visible`;
      this[`${modalName}`] = false;
    },
  },
  created() {
    this.queryData();
  },
};
</script>
<style>
    .block {
        float: right;
    }
    .el-cascader-menu{
        height: 90px;
    }
</style>




// WEBPACK FOOTER //
// src/components/accountClose.vue